import UserIcon from '../User';

export const AccountIcon = UserIcon;
export default AccountIcon;
